import { GET_VIEW_PROPERTY_DETAILS, RESET_VIEW_PROPERTY_DETAILS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface ViewPropertyDetailsState extends BaseAsyncReducerState {
    propertyDetails?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: ViewPropertyDetailsState  = {
    loading: false,
    error: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function viewPropertyDetailsReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_VIEW_PROPERTY_DETAILS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_VIEW_PROPERTY_DETAILS.SUCCESS:
            return {
                ...state,
                propertyDetails: payload,
                loading: false,
                error: false

            }
        case GET_VIEW_PROPERTY_DETAILS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_VIEW_PROPERTY_DETAILS:
            return {
                ...state,
                propertyDetails: null
            }
        default:
            return state
    }
}

export default viewPropertyDetailsReducer;